const PLAN_TYPE = {
  TRIAL: 'TRIAL',
  PAID: 'PAID',
}

const QUOTA_MODE = {
  RESOURCE: 'RESOURCE',
  USER_LIMIT: 'USER_LIMIT',
}

const FILE_ACCESS_LEVEL = {
  DOWNLOAD_AND_PREVIEW: 'download_and_preview',
  PREVIEW_ONLY: 'preview_only',
  NO_ACCESS: 'no_access',
}

export { QUOTA_MODE, FILE_ACCESS_LEVEL }
export default PLAN_TYPE
